import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full p-4" }
const _hoisted_2 = { class: "flex flex-row mb-2 justify-items-center" }
const _hoisted_3 = { class: "flex w-full text-2xl text-black" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon-close mr-2" }, null, -1)
const _hoisted_5 = { class: "flex flex-col w-full space-y-2" }
const _hoisted_6 = { class: "flex flex-row space-x-4" }
const _hoisted_7 = { class: "flex flex-col w-full md:w-1/2 pr-4" }
const _hoisted_8 = { class: "ml-2 mb-2 text-lg uppercase font-bold text-black" }
const _hoisted_9 = { class: "flex flex-row" }
const _hoisted_10 = { class: "flex flex-col w-full md:w-1/2 pr-4" }
const _hoisted_11 = { class: "ml-2 mb-2 text-lg uppercase font-bold text-black" }
const _hoisted_12 = { class: "flex flex-col w-full md:w-1/2 pr-4" }
const _hoisted_13 = { class: "ml-2 mb-2 text-lg uppercase font-bold text-black" }
const _hoisted_14 = { class: "flex flex-row" }
const _hoisted_15 = { class: "flex flex-col w-full md:w-1/2 pr-4" }
const _hoisted_16 = { class: "ml-2 mb-2 text-lg uppercase font-bold text-black" }
const _hoisted_17 = { class: "flex flex-col w-full md:w-1/2 pr-4" }
const _hoisted_18 = { class: "ml-2 mb-2 text-lg uppercase font-bold text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_vue_multiselect = _resolveComponent("vue-multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(
                'proposal.suppliers.modal_form.section_title',
                {number: _ctx.index + 1}
            )), 1),
      _createVNode(_component_outline_button, {
        type: "outline",
        onClick: _ctx.removeSection
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('proposal.suppliers.modal_form.remove_button')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('proposal.suppliers.modal_form.fields_labels.supplier')), 1),
          _createVNode(_component_vue_multiselect, {
            options: _ctx.suppliersOptions,
            id: "suppliers",
            label: "name",
            "track-by": "id",
            modelValue: _ctx.supplierParams[_ctx.SupplierFields.suppliers][0],
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.supplierParams[_ctx.SupplierFields.suppliers][0]) = $event)),
              _ctx.supplierSelection
            ]
          }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('proposal.suppliers.modal_form.fields_labels.countries')), 1),
          _createVNode(_component_vue_multiselect, {
            options: [
                  {
                      groupName: _ctx.$t('proposal.suppliers.modal_form.select_all'),
                      options: _ctx.countriesOptions,
                  },
              ],
            disabled: !_ctx.countriesOptions.length,
            "close-on-select": false,
            multiple: true,
            "group-select": true,
            limit: 4,
            "group-label": "groupName",
            "group-values": "options",
            id: "countries",
            label: "name",
            "track-by": "id",
            modelValue: _ctx.supplierParams[_ctx.SupplierFields.countries],
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.supplierParams[_ctx.SupplierFields.countries]) = $event)),
              _ctx.countriesSelection
            ]
          }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('proposal.suppliers.modal_form.fields_labels.products')), 1),
          _createVNode(_component_vue_multiselect, {
            options: [
                  {
                      groupName: _ctx.$t('proposal.suppliers.modal_form.select_all'),
                      options: _ctx.productsOptions,
                  },
              ],
            disabled: !_ctx.productsOptions.length,
            "close-on-select": false,
            multiple: true,
            "group-select": true,
            limit: 4,
            "group-label": "groupName",
            "group-values": "options",
            id: "products",
            label: "name",
            "track-by": "id",
            modelValue: _ctx.supplierParams[_ctx.SupplierFields.products],
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.supplierParams[_ctx.SupplierFields.products]) = $event)),
              _ctx.productsSelection
            ]
          }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('proposal.suppliers.modal_form.fields_labels.contracts')), 1),
          _createVNode(_component_vue_multiselect, {
            options: [
                  {
                      groupName: _ctx.$t('proposal.suppliers.modal_form.select_all'),
                      options: _ctx.contractsOptions,
                  },
              ],
            disabled: !_ctx.contractsOptions.length,
            "close-on-select": false,
            multiple: true,
            "group-select": true,
            limit: 4,
            "group-label": "groupName",
            "group-values": "options",
            id: "contracts",
            label: "name",
            "track-by": "id",
            modelValue: _ctx.supplierParams[_ctx.SupplierFields.contracts],
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.supplierParams[_ctx.SupplierFields.contracts]) = $event)),
              _ctx.contractsSelection
            ]
          }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('proposal.suppliers.modal_form.fields_labels.services')), 1),
          _createVNode(_component_vue_multiselect, {
            options: [
                  {
                      groupName: _ctx.$t('proposal.suppliers.modal_form.select_all'),
                      options: _ctx.servicesOptions,
                  },
              ],
            disabled: !_ctx.servicesOptions.length,
            "close-on-select": false,
            multiple: true,
            "group-select": true,
            limit: 4,
            "group-label": "groupName",
            "group-values": "options",
            id: "services",
            label: "name",
            "track-by": "id",
            modelValue: _ctx.supplierParams[_ctx.SupplierFields.services],
            "onUpdate:modelValue": [
              _cache[4] || (_cache[4] = ($event: any) => ((_ctx.supplierParams[_ctx.SupplierFields.services]) = $event)),
              _ctx.servicesSelection
            ]
          }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"])
        ])
      ])
    ])
  ]))
}